import { MemberTableColumn } from './data';

type MemberTableColumnsOptions = {
  showGroup: boolean;
  showActivity: boolean;
  showChat: boolean;
};

export const getMemberTableColumns = ({
  showGroup,
  showActivity,
  showChat,
}: MemberTableColumnsOptions) => {
  const cols: MemberTableColumn[] = ['name'];
  if (showGroup) cols.push('group');
  cols.push('files', 'qa');
  if (showActivity)
    cols.push('status', 'views', 'questionsColumn', 'downloads', 'lastSeen');
  cols.push('teams');
  if (showChat) cols.push('chatColumn');
  cols.push('actions');
  return cols;
};
